import React, { useState } from "react";
import DateRangePicker from "../../../../components/DataRangePicker";

export default function RegistersDateRange({
  value = "Seleccionar rango",
  onChange = () => {},
  dateRangeOptions,
  addedRanges = {},
  enabled = true,
  className = "",
}) {
  const [isDateRangeOpen, setDateRangeOpen] = useState(false);

  const handleDateRangeClick = () => {
    if (!enabled) return;
    setDateRangeOpen((prev) => !prev);
  };

  const handleDateRangeChange = (event) => {
    onChange(event);
    setDateRangeOpen(false);
  };

  return (
    <div className="relative inline-block">
      
      {/* Badge */}
      <button
        type="button"
        onClick={handleDateRangeClick}
        disabled={!enabled}
        className={
          "flex items-center gap-2  px-4 py-2 text-sm font-medium rounded-full border transition-all " +
          (enabled
            ? "bg-blue-50 border-blue-200 text-blue-900 hover:bg-blue-100"
            : "bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed") +
          " " +
          className
        }
      >
        {/* Icon calendario */}
        <svg
          className="w-4 h-4 opacity-70"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <rect x="3" y="4" width="18" height="18" rx="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>

        {value}

        {/* Flecha */}
        <svg
          className={
            "w-4 h-4 transition-transform " +
            (isDateRangeOpen ? "rotate-180" : "")
          }
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>

      {/* DateRangePicker */}
      {isDateRangeOpen && (
        <div className="absolute right-0 w-[40rem] z-50 mt-2">
          <div className="bg-white border border-gray-300 rounded-lg shadow-lg">
            <DateRangePicker
              onChange={handleDateRangeChange}
              closeWindow={() => setDateRangeOpen(false)}
              options={dateRangeOptions}
              addRanges={addedRanges}
            />
          </div>
        </div>
      )}
    </div>
  );
}